import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { CoreModule } from './core/core.module';
import { HomeModule } from './home/home.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { MatSliderModule } from '@angular/material/slider';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';

// --- Previously Added Imports ---
import { MatIconModule } from '@angular/material/icon'; 
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// --- NEW Imports (Required for the updated UI) ---
import { MatCardModule } from '@angular/material/card';        // For <mat-card>
import { MatButtonModule } from '@angular/material/button';    // For <mat-button>, <mat-raised-button>
import { MatSelectModule } from '@angular/material/select';    // For <mat-select>, <mat-option>
import { MatTableModule } from '@angular/material/table';      // For <table mat-table>
import { MatPaginatorModule } from '@angular/material/paginator'; // For <mat-paginator>
import { MatSortModule } from '@angular/material/sort';        // For matSort
import { MatSlideToggleModule } from '@angular/material/slide-toggle'; // For <mat-slide-toggle>
import { MatSnackBarModule } from '@angular/material/snack-bar'; // For MatSnackBar alerts

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    HomeModule,
    NgxSpinnerModule,
    HttpClientModule,
    SharedModule,
    NgxUiLoaderModule,
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
    }),
    MatSliderModule,
    
    // Existing Material Imports
    MatIconModule,     
    MatFormFieldModule, 
    MatInputModule,

    // --- Add these to the imports array ---
    MatCardModule,
    MatButtonModule,
    MatSelectModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSlideToggleModule,
    MatSnackBarModule,
  ],
  providers: [
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }